import { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useStepsContext } from '../context/StepsContext'
import { replaceWhiteSpaces } from '../utils/utils'
import useValidate from './useValidate'

const useInput = (name: string, storeForm: string, isSelect?: boolean, optional?: boolean, disabled?: boolean) => {
  const { clearSearch }: any = useStepsContext()
  const reduxInput = useSelector((state: any) => state[storeForm][name])
  const { resetSteps }: any = useStepsContext()
  const [error, setError] = useState('')
  const [input, setInput] = useState(reduxInput)
  const [validity, setValidity] = useState(false)
  const itemRef = useRef<HTMLIonItemElement>(null)
  const { validate } = useValidate()
  const [firstFocus, setFirstFocus] = useState(true)
  const secondReduxInput: any = useSelector((state: any) => {
    if (name === 'cardNumber') return state[storeForm].chipNumber
    else if (name === 'chipNumber') return state[storeForm].cardNumber
    else if (name === 'securityCode') return state[storeForm].birthDate
  })

  useEffect(() => {
    if (
      (['names', 'lastName', 'sex', 'birthDate'].includes(name) && storeForm === 'idNominativityForm') ||
      name === 'accAddressCity'
    )
      setInput('')
  }, [clearSearch])

  useEffect(() => {
    if (['geuDescription', 'accAddressCity'].includes(name)) return
    !reduxInput && setInput('')
  }, [resetSteps]) // eslint-disable-line

  const clearError = () => {
    if (validity) setValidity(false)
    setError('')
    itemRef.current?.classList.remove('error')
  }

  const reValidate = () => {
    if (validity) setValidity(false)
    const errorOnValidity = validate(input, 'securityCode')
    if (input.length === 8) {
      setError(errorOnValidity)
      itemRef.current?.classList.add('error')
    }
    if (!errorOnValidity && input) {
      setValidity(true)
      itemRef.current?.classList.remove('error')
    }
  }

  useEffect(() => {
    if (secondReduxInput && storeForm !== 'idPrepagaForm') clearError()
    if (secondReduxInput && storeForm === 'idPrepagaForm' && name === 'securityCode') reValidate()
  }, [secondReduxInput, input])

  const handleError: any = () => {
    if (optional && !input) return
    if (firstFocus && isSelect) return setFirstFocus(false)
    const errorOnValidity = validate(input, name)
    setError(errorOnValidity)
    !disabled && itemRef.current?.classList.add('error')
    if (!errorOnValidity && input) {
      setValidity(true)
      itemRef.current?.classList.remove('error')
    }
    if (secondReduxInput && storeForm !== 'idPrepagaForm') clearError()
  }

  const handleInput: any = useCallback((event: any) => {
    const currentInput = name === 'documentNumber' ? replaceWhiteSpaces(event.detail.value) : event.detail.value
    const errorOnValidity = validate(currentInput, name)
    validity && setValidity((prev: boolean) => false)
    setError((prev: string) => '')
    setInput((prev: string) => currentInput)
    if (!errorOnValidity) {
      itemRef.current?.classList.remove('error')
      setValidity((prev: boolean) => true)
    } else {
      setValidity((prev: boolean) => false)
    }
  }, [])

  return {
    reduxInput,
    error,
    input,
    itemRef,
    setInput,
    setError,
    handleError,
    handleInput,
    clearError,
    validity
  }
}

export default useInput
